(function () {
function $d5f992f8158b4022$export$21a5e8c01990eb73() {
    $("#main-navigation").removeClass("-translate-y-full");
    $("#hamburger .open").addClass("hidden");
    $("#hamburger .close").removeClass("hidden");
}
function $d5f992f8158b4022$export$c9e788aaf7edc9f8() {
    $("#main-navigation").addClass("-translate-y-full");
    $("#hamburger .close").addClass("hidden");
    $("#hamburger .open").removeClass("hidden");
    $d5f992f8158b4022$export$ee206ecf4be58087();
}
function $d5f992f8158b4022$export$f9a18a9193a8c2f0(index) {
    index.slideToggle();
    index.parent().find(".subnav-ind").toggleClass("rotate-180");
}
function $d5f992f8158b4022$export$ee206ecf4be58087() {
    $(".subnav").addClass("hidden").css("display", "");
    $(".subnav-ind").removeClass("rotate-180");
}


// Stop transitions before page has loaded
$(window).on("load", function() {
    $("body").removeClass("preload");
});
// Toggle navigation
$("#hamburger").click(function(e) {
    e.preventDefault();
    $("#main-navigation").hasClass("-translate-y-full") ? (0, $d5f992f8158b4022$export$21a5e8c01990eb73)() : (0, $d5f992f8158b4022$export$c9e788aaf7edc9f8)();
});
$(".toggle-subnav").click(function(e) {
    var subnav = $(this).next(".subnav");
    (0, $d5f992f8158b4022$export$f9a18a9193a8c2f0)(subnav);
});
// Carousel
var $089c40fcbb903d20$var$swiper = new Swiper(".swiper", {
    loop: true,
    theshold: 2,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function(index, className) {
            return '<span class="' + className + ' inline-block w-8 h-1 mx-1 bg-antich-blue rounded-sm transition"></span>';
        }
    }
});
// Stories
$(".story-toggle").click(function() {
    $(".story-toggle").removeClass("text-antich-blue").addClass("text-antich-blue/30");
    $(this).addClass("text-antich-blue").removeClass("text-antich-blue/30");
    $(".story").addClass("hidden");
    $(".story").eq($(this).index()).removeClass("hidden");
});

})();
//# sourceMappingURL=main.js.map
